{
  "articlesSection": "기사",
  "bookmarkTitleLabel": "책갈피",
  "communitiesSection": "커뮤니티 토론",
  "devConnectionLabel": "개발자 연결",
  "feedback": "피드백",
  "fetchFailed": "가져오기 실패",
  "help": "도움말",
  "helpLoadError": "문제가 발생했습니다. 다시 시도하십시오.",
  "noBookmarks": "여기서 액세스할 수 있도록 도움말 컨텐츠를 책갈피에 추가",
  "noBookmarksTitle": "책갈피 없음",
  "noResults": "결과  없음",
  "noResultsMessage": "맞춤법을 확인하거나 다른 검색어를 사용해 보십시오.",
  "resourcesCustomerCareLabel": "고객 지원 센터",
  "resourcesStatusLabel": "상태",
  "solutionsFilterLabel": "모든 솔루션",
  "support": "지원",
  "videosSection": "비디오"
}
